// To override Launch Darkly settings to turn on a flag
// you may set the flag value to true (boolean, not string)

// List of feature flags that should always return true
export const AUTO_ENABLED_FLAGS = [
];

// List of feature flags that should always return false
export const AUTO_DISABLED_FLAGS = [
];
